import { ApiEnums } from "@/lib/api/api";
import { getLocale } from "@/components/base/translate/Translate";
import { getSite } from "@/components/hooks/useSiteConfig";

const HELPTEXT_FIELDS = `
  documentId
  title
  body
  group
  image {
    url
    alternativeText
    width
    height
  }
`;

/**
 * All published help texts — used for the landing page sections and sidebar menu.
 */
export function publishedHelptexts({ locale = getLocale() } = {}) {
  const site = getSite();
  return {
    apiUrl: ApiEnums.FBI_API,
    query: `query PublishedHelptextsQuery($locale: BibliotekdkCmsI18NLocaleCode, $site: String!) {
      bibliotekdkCms {
        helpTexts(
          status: PUBLISHED,
          locale: $locale,
          pagination: { limit: 100 },
          filters: { sites: { name: { eq: $site } } }
        ) {
          ${HELPTEXT_FIELDS}
        }
      }
    }`,
    variables: { locale, site },
    slowThreshold: 3000,
  };
}

/**
 * Single help text by documentId.
 */
export function helpText({ helpTextId }) {
  const locale = getLocale();
  const site = getSite();
  return {
    apiUrl: ApiEnums.FBI_API,
    query: `query HelptextByIdQuery($documentId: ID!, $locale: BibliotekdkCmsI18NLocaleCode, $site: String!) {
      bibliotekdkCms {
        helpTexts(
          status: PUBLISHED,
          locale: $locale,
          filters: {
            documentId: { eq: $documentId },
            sites: { name: { eq: $site } }
          }
        ) {
          ${HELPTEXT_FIELDS}
          createdAt
          updatedAt
        }
      }
    }`,
    variables: { documentId: helpTextId, locale, site },
    slowThreshold: 3000,
  };
}

export function helpTextSearch({ q }) {
  const site = getSite();

  return {
    apiUrl: ApiEnums.FBI_API,
    delay: 100,
    query: `query HelpTextSearchQuery($q: String!, $site: String!) {
      bibliotekdkCms {
        helpTexts(
          status: PUBLISHED
          pagination: { limit: 20 }
          filters: {
            sites: { name: { eq: $site } }
            or: [
              { title: { containsi: $q } }
              { body: { containsi: $q } }
            ]
          }
        ) {
          documentId
          title
          body
          group
        }
      }
      monitor(name: "helptext_search")
    }`,
    variables: { q, site },
    slowThreshold: 3000,
  };
}
